import albumTrackApi from "../apis/albumTrackApi";
import { apiCallBegin, apiCallSuccess, apiCallError } from "./loading";

export const ACTION_TYPES = {
    CREATE_SONG: 'CREATE_SONG',
    UPDATE_SONG: 'UPDATE_SONG',
    DELETE_SONG: 'DELETE_SONG',
    FETCH_ALL_SONGS_BY_ALBUM: 'FETCH_ALL_SONGS_BY_ALBUM'
}

export const fetchAll = (albumId) => dispatch => {
    dispatch(apiCallBegin());
    return albumTrackApi.albumTrack().fetchAll(albumId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_ALL_SONGS_BY_ALBUM,
                payload: response.data
            });
            dispatch(apiCallSuccess());
            return Promise.resolve(response);
        })
        .catch(err => {
            dispatch(apiCallError());
            return Promise.reject(err);
        })
}

export const create = (song) => dispatch => {
    dispatch(apiCallBegin());
    return albumTrackApi.albumTrack().create(song)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.CREATE_SONG,
                payload: { ...song, id: response.data.id }
            });
            dispatch(apiCallSuccess());
            return Promise.resolve(response);
        })
        .catch(err => {
            dispatch(apiCallError());
            return Promise.reject(err);
        })
}

export const update = (song) => dispatch => {
    dispatch(apiCallBegin());
    return albumTrackApi.albumTrack().update(song.id, song)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.UPDATE_SONG,
                payload: song
            });
            dispatch(apiCallSuccess());
            return Promise.resolve(response);
        })
        .catch(err => {
            dispatch(apiCallError());
            return Promise.reject(err);
        })
}

export const deleteTrack = (id) => dispatch => {
    dispatch(apiCallBegin());
    return albumTrackApi.albumTrack().delete(id)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.DELETE_SONG,
                payload: id
            });
            dispatch(apiCallSuccess());
            return Promise.resolve(response);
        })
        .catch(err => {
            dispatch(apiCallError());
            return Promise.reject(err);
        })
}